import { Collection, WhereField } from '../../shared/constants'
import { addDoc, deleteDoc, getAllDocsByClientId, getAllDocsByParkId, getAllDocsByQueries, updateDoc } from './collectionBaseWorker'
import { where } from "firebase/firestore"

export const getAllEquipmentsByClientId = async ({ clienteId }) => {
    return await getAllDocsByClientId({ collection: Collection.EQUIPMENTS, clienteId: clienteId })
}

export const getAllEquipmentsByParkId = async ({ estacionamentoId }) => {
    const docs = await getAllDocsByParkId({ collection: Collection.EQUIPMENTS, estacionamentoId: estacionamentoId })
    return docs
}

export const getAllEquipmentsByLPRIdentifierAndParkId = async ({ lprIdentifier, estacionamentoId }) => {
    return await getAllDocsByQueries({
        collection: Collection.EQUIPMENTS,
        queries: [
            where(WhereField.PARKID, "==", estacionamentoId),
            where(WhereField.LPR_IDENTIFIER, "==", lprIdentifier)
        ]
    })
}

export const addEquipment = async ({ data }) => {
    await addDoc({ collection: Collection.EQUIPMENTS, data: data })
}

export const updateEquipmentById = async ({ id, data }) => {
    await updateDoc({ collection: Collection.EQUIPMENTS, id: id, data: data })
}

export const deleteEquipment = async ({ id }) => {
    await deleteDoc({ collection: Collection.EQUIPMENTS, id: id })
}
